import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styles from './DocumAside.module.scss';

const DocumAside = ({ onFilterChange }) => {
  const categories = useSelector((state) => state.documents.categories) || [];
  const [openCategories, setOpenCategories] = useState({});
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);

  // Обработчик нажатия на категорию (переключение раскрытия)
  const handleCategoryToggle = (categoryId) => {
    setOpenCategories((prev) => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
    // Сбрасываем подкатегории других категорий при открытии новой
    setSelectedSubcategories((prev) =>
      prev.filter((subId) =>
        categories.find((cat) => cat.id === categoryId)?.subcategories.some((sub) => sub.id === subId),
      ),
    );
  };

  // Обработчик выбора чекбокса
  const handleCheckboxChange = (subcategoryId) => {
    setSelectedSubcategories((prev) => {
      if (prev.includes(subcategoryId)) {
        return prev.filter((id) => id !== subcategoryId);
      }
      return [...prev, subcategoryId];
    });
  };

  // Передача выбранных подкатегорий в родительский компонент
  useEffect(() => {
    onFilterChange(selectedSubcategories);
  }, [selectedSubcategories, onFilterChange]);

  return (
    <ul className={styles.list}>
      {categories.map((category) => (
        <li className={styles.item} key={category.id}>
          <button
            className={`${styles.button} ${openCategories[category.id] ? styles.pressed : ''}`}
            onClick={() => handleCategoryToggle(category.id)}>
            {category.name}
          </button>
          {openCategories[category.id] && (
            <ul className={styles.filterbox}>
              {category.subcategories?.map((subcategory) => (
                <li className={styles.filteritem} key={subcategory.id}>
                  <label>
                    <input
                      type="checkbox"
                      className="visually-hidden"
                      checked={selectedSubcategories.includes(subcategory.id)}
                      onChange={() => handleCheckboxChange(subcategory.id)}
                    />
                    <span className={styles.mark}></span>
                    <span className={styles.name}>{subcategory.name}</span>
                  </label>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
};

export default DocumAside;
